import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET,
  GET_SITES_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_ERROR,
  AUTH_REFRESH_ERROR,
  AUTH_REFRESH_START,
  AUTH_REFRESH_SUCCESS,
  FETCH_USER_START,
  FETCH_USER_SUCCESS,
  FETCH_USER_ERROR,
  SIGNIN_USER_START,
  SIGNOUT_USER_ERROR,
  SIGNOUT_USER_START,
  SET_USER_ROLE,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_START,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR,
  VERIFY_OTP_START,
  VERIFY_OTP_ERROR,
  VERIFY_OTP_SUCCESS,
  UPDATE_MIP_DATA,
  SET_USER_SITE,

} from "../../constants/ActionTypes";
import axios from "../../util/axiosConfig";
import uuidv1 from 'uuid/v1';
import { history } from '../store';
import { LOGIN_ERROR } from "../../constants/messages";
import { FETCH_MODALITY_TYPES } from "./common/modality-action";
import { APP_MESSAGE_BROADCAST_CHANNEL } from "../../constants/constants";
import { getErrorMessage } from '../../util/ErrorUtils';
import { GET_USER_SESSION_DATA } from "./userLocalStorageSession";
import { message } from 'antd';
import { getUserAllowedRisWithMipsAPI } from "../../services/users-service";
import { verifyOtpAPI } from "../../services/auth.service";
import { navigateTo } from "../../util/navigationService";
export const NEW_SESSION_CREATED = 'NEW_SESSION_CREATED';

let authRefreshInFlight = null;
let signOutInFlight = null;

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const userSignUp = ({ email, password, name }) => {
  // console.log(email, password);
  // return (dispatch) => {
  //   dispatch({type: FETCH_START});
  //   axios.post('auth/register', {
  //       email: email,
  //       password: password,
  //       name: name
  //     }
  //   ).then(({data}) => {
  //     console.log("data:", data);
  //     if (data.result) {
  //       localStorage.setItem("token", JSON.stringify(data.token.access_token));
  //       axios.defaults.headers.common['access-token'] = "Bearer " + data.token.access_token;
  //       dispatch({type: FETCH_SUCCESS});
  //       dispatch({type: USER_TOKEN_SET, payload: data.token.access_token});
  //       dispatch({type: USER_DATA, payload: data.user});
  //     } else {
  //       console.log("payload: data.error", data.error);
  //       dispatch({type: FETCH_ERROR, payload: "Network Error"});
  //     }
  //   }).catch(function (error) {
  //     dispatch({type: FETCH_ERROR, payload: error.message});
  //     console.log("Error****:", error.message);
  //   });
  // }
};

export const userSignIn = (email, password) => {
  return (dispatch) => {
    dispatch({ type: SIGNIN_USER_START });
    axios.post('api/auth/signin', {
      email: email,
      password: password,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
    ).then(({ data }) => {      
      const USESSIONID = uuidv1();
      if (data) {
        const user = {
          ...data,
          authenticated: false,
          created_at: new Date(),
          email_verified_at: null,
          role: data.roles.length === 1 ? data.roles[0].name : null,
          site: data.mips.length === 1 ? data.mips[0] : null,
          updated_at: new Date(),
          mips: data.mips,
        }
        sessionStorage.setItem("user", JSON.stringify(user));
        sessionStorage.setItem("mips", JSON.stringify(data.mips));
        sessionStorage.setItem("USESSIONID", USESSIONID);
        dispatch({ type: SIGNIN_USER_SUCCESS });
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: USER_DATA, payload: user });
        dispatch({ type: GET_SITES_SUCCESS, mips: data.mips });
        // dispatch({ type: FETCH_MODALITY_TYPES });

        const channel = new BroadcastChannel(APP_MESSAGE_BROADCAST_CHANNEL);
        const obj = {
          action: NEW_SESSION_CREATED,
          payload: {
            sessionId: USESSIONID
          }
        }
        channel.postMessage(obj);
        navigateTo('/');

      } else {
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    }).catch(function (error) {
      // dispatch({ type: FETCH_ERROR, payload: LOGIN_ERROR });
      const errorMsg = getErrorMessage(error);
      if (errorMsg) {
        message.error(errorMsg);
        dispatch({ type: SIGNIN_USER_ERROR, payload: errorMsg });
      } else {
        message.error(LOGIN_ERROR);
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    });
  }
};


export const verifyOtp = (payload) => {
  return async (dispatch) => {
    dispatch({ type: VERIFY_OTP_START });
    const response = await verifyOtpAPI(payload);
    if (response.success) {
      dispatch({ type: VERIFY_OTP_SUCCESS });
      dispatch({ type: FETCH_MODALITY_TYPES });
    } else {
      if (response.error) {
        message.error(response.error);
      } else {
        message.error("Failed to verify OTP!");
      }
      dispatch({ type: VERIFY_OTP_ERROR });
    }
  }
}

// export const userSignIn = ({email, password}) => {
//   return (dispatch) => {
//     dispatch({type: FETCH_START});
//     axios.post('auth/login', {
//         email: email,
//         password: password,
//       }
//     ).then(({data}) => {
//       console.log("userSignIn: ", data);
//       if (data.result) {
//         localStorage.setItem("token", JSON.stringify(data.token.access_token));
//         axios.defaults.headers.common['access-token'] = "Bearer " + data.token.access_token;
//         dispatch({type: FETCH_SUCCESS});
//         dispatch({type: USER_TOKEN_SET, payload: data.token.access_token});
//       } else {
//         dispatch({type: FETCH_ERROR, payload: data.error});
//       }
//     }).catch(function (error) {
//       dispatch({type: FETCH_ERROR, payload: error.message});
//       console.log("Error****:", error.message);
//     });
//   }
// };

export const getUser = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_USER_START });
    axios.get('/api/v1/user/me')
      .then(({ data }) => {
        if (data) {          
          const user = {
            ...data,
            created_at: new Date(),
            email_verified_at: null,
            role: data.roles.length === 1 ? data.roles[0].name : null,
            site: data.mips.length === 1 ? data.mips[0] : null,
            updated_at: new Date(),
          }
          sessionStorage.setItem("user", JSON.stringify(user));
          dispatch({ type: FETCH_USER_SUCCESS });
          dispatch({ type: USER_DATA, payload: user });
          dispatch({ type: AUTH_REFRESH_SUCCESS });
        } else {
          dispatch(userSignOut());
          dispatch({ type: FETCH_USER_ERROR });
        }
      }).catch(function (error) {
        dispatch(userSignOut());
        dispatch({ type: FETCH_USER_ERROR });
      });
  }
};



export const authRefresh = (appLoading) => {
  return async (dispatch, getState) => {
    // App remounts or overlapping timers must share the same refresh operation.
    if (authRefreshInFlight) {
      return authRefreshInFlight;
    }

    if (appLoading) {
      dispatch({ type: AUTH_REFRESH_START });
    }

    const handleRefreshSuccess = () => {
      const { auth } = getState();

      if (!auth.authUser) {
        dispatch(getUser());
      } else {
        dispatch({ type: AUTH_REFRESH_SUCCESS });
        dispatch({ type: GET_USER_SESSION_DATA, email: auth.authUser.email });
      }
    };

    const refresh = async () => {
      try {
        await axios.post('/api/auth/refresh');
        handleRefreshSuccess();
      } catch (error) {
        const status = error && error.response && error.response.status;
        const isAuthFailure = status === 401 || status === 403;

        if (isAuthFailure) {
          dispatch(userSignOut());
          dispatch({ type: AUTH_REFRESH_ERROR });
          return;
        }

        // A network error, timeout or overloaded backend is not proof that the
        // session expired. Retry once, then leave the local session intact.
        try {
          await axios.post('/api/auth/refresh');
          handleRefreshSuccess();
        } catch (retryError) {
          const retryStatus = retryError && retryError.response && retryError.response.status;

          if (retryStatus === 401 || retryStatus === 403) {
            dispatch(userSignOut());
          } else {
            console.error('authRefresh: retry also failed', retryError);
          }

          dispatch({ type: AUTH_REFRESH_ERROR });
        }
      }
    };

    authRefreshInFlight = refresh();

    try {
      return await authRefreshInFlight;
    } finally {
      authRefreshInFlight = null;
    }
  }
};

export const resetReduxStore = () => {
  return (dispatch) => {
    dispatch({ type: SIGNOUT_USER_SUCCESS });
  }
}

export const userSignOut = () => {
  return (dispatch, getState) => {
    if (signOutInFlight) {
      return signOutInFlight;
    }

    const { auth } = getState();

    // Optimization: If no user is logged in, skip the API call but clear state to stop spinner
    if (!auth || !auth.authUser) {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("mips");
      sessionStorage.removeItem("modalityTypes");
      sessionStorage.removeItem("USESSIONID");
      dispatch({ type: SIGNOUT_USER_SUCCESS });
      return;
    }

    dispatch({ type: SIGNOUT_USER_START });
    signOutInFlight = axios.post('/api/auth/signout')
      .then(({ data }) => {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("mips");
        sessionStorage.removeItem("modalityTypes");
        sessionStorage.removeItem("USESSIONID");
        if (auth && auth.authUser) {
          localStorage.removeItem(auth.authUser.email);
        }
        if (localStorage.getItem("filterSettings")) {
          localStorage.removeItem("filterSettings");  
        }
        if (localStorage.getItem("aptFilterSettings")) {
          localStorage.removeItem("aptFilterSettings");  
        }
        // dispatch({ type: CLOSE_SESSION });
        dispatch({ type: SIGNOUT_USER_SUCCESS });
      }).catch(function (error) {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("USESSIONID");
        dispatch({ type: SIGNOUT_USER_ERROR });
      }).finally(() => {
        signOutInFlight = null;
      });

    return signOutInFlight;
  }
};

export const setUserRole = (role) => {
  return (dispatch) => {
    dispatch({ type: SET_USER_ROLE, role });
    dispatch(fetchUserAllowedRisWithMips(role));
    navigateTo({
      pathname: role ? '/' : '/user-role-selection',
    });
  }
}

export const setUserSite = (site) => {
  return (dispatch) => {
    dispatch({ type: SET_USER_SITE, site });
    // store in session storage also
    let user = JSON.parse(sessionStorage.getItem("user")) || {};
    user.site = site;
    sessionStorage.setItem("user", JSON.stringify(user));
  };
};

export const fetchUserAllowedRisWithMips = (sessionRole) => {
  return async (dispatch) => {
    const response = await getUserAllowedRisWithMipsAPI(sessionRole);
    if (response && response.success) {
      dispatch({
        type: FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS,
        risWithMips: response.risWithMips
      });
    } else {
      dispatch({
        type: FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR
      })
    }
  }
}

export const updateMipData = (payload) => {
  return {
    type: UPDATE_MIP_DATA,
    payload: payload
  }
}
